import { createRouter, createWebHistory } from "vue-router";
import { buildLoginUrl, getAuthCheckUrl, getRouterBase } from "@/config";

/**
 * ------------------------------------------------------------------
 * Router Configuration
 * ------------------------------------------------------------------
 *
 * In local development the app is served from:
 *
 *     http://localhost:PORT/
 *
 * while /oauth2 and /api are proxied by vue-cli to the
 * remote /app3 gateway.
 */

// ─── View Imports ─────────────────────────────────────────────────

import Services from '@/views/Services/ServicesView.vue';
import BirthDoc from '@/views/Documents/BirthView.vue';
import FirstBirtDoc from '@/views/Documents/FirstBirthView.vue';
import DeathDoc from '@/views/Documents/DeathView.vue';
import NidDoc from '@/views/Documents/NidView.vue';
import DivorceDoc from '@/views/Documents/DivorceView.vue';
import MarriageDoc from '@/views/Documents/MarriageView.vue';
import PersonalRecord from '@/views/Documents/PersonalRecordView.vue';
import FamilyRecord from '@/views/Documents/FamilyRecordView.vue';
import NidForm from "@/views/Documents/NidFormView.vue";

import TranslatedServices from '@/views/Services/TranslatedServicesView.vue';
import translatedBirthDoc from '@/views/TranslatedDocs/BirthView.vue';
import translatedDeathDoc from '@/views/TranslatedDocs/DeathView.vue';
import translatedDivorceDoc from '@/views/TranslatedDocs/DivorceView.vue';
import translatedMarriageDoc from '@/views/TranslatedDocs/MarriageView.vue';
import translatedPersonalRecord from '@/views/TranslatedDocs/PersonalRecordView.vue';
import translatedFamilyRecord from '@/views/TranslatedDocs/FamilyRecordView.vue';

import Home from '@/views/Home/HomeView.vue';
import Dashboard from '@/views/Home/DashboardView.vue';
import ServicesComp from '@/components/Services.vue';
import allServices from '@/components/Home/Services.vue';

import DocRegulations from '@/views/Regulations/DocRegView.vue';
import translatedDocsReg from '@/views/Regulations/TranslatedDocsView.vue';

import About from '@/components/Navigation/About.vue';
import Complains from '@/components/Navigation/Complains.vue';
import Inquiry from '@/components/Navigation/Inquiry.vue';
import InquiryResult from '@/components/InquiryResult.vue';
import Questions from '@/components/Navigation/Questions.vue';
import IdealCenters from '@/components/Navigation/IdealCenters.vue';
import Contactus from '@/components/Navigation/Contactus.vue';

import SmartRecords from '@/components/Home/SmartRecords.vue';
import RecordsLocation from '@/components/Home/RecordsLocation.vue';

import News1 from '@/components/News/News1.vue';
import News2 from '@/components/News/News2.vue';
import News3 from '@/components/News/News3.vue';
import News4 from '@/components/News/News4.vue';
import News5 from '@/components/News/News5.vue';
import News6 from '@/components/News/News6.vue';
import News7 from '@/components/News/News7.vue';
import News8 from '@/components/News/News8.vue';
import News9 from '@/components/News/News9.vue';

import Sent from '@/views/SentView.vue';
import Soon from '@/views/SoonView.vue';


// ─── Routes ───────────────────────────────────────────────────────

const routes = [
{
path: '/',
name: 'HomePage',
component: Home,
children: [

{ path: '', name: 'dashboard', component: Dashboard },
{ path: 'Login', name: 'Login', component: Dashboard },
{ path: '', name: 'servicesdash', component: allServices, hash: 'services' },

{ path: 'about', name: 'about', component: About },
{ path: 'complains', name: 'complains', component: Complains },
{ path: 'questions', name: 'questions', component: Questions },
{ path: 'smartrecords', name: 'smartrecords', component: SmartRecords },
{ path: 'recordslocation', name: 'recordslocation', component: RecordsLocation },
{ path: 'idealcenters', name: 'idealcenters', component: IdealCenters },
{ path: 'contactus', name: 'contactus', component: Contactus },

// news
{ path: 'news1', name: 'news1', component: News1 },
{ path: 'news2', name: 'news2', component: News2 },
{ path: 'news3', name: 'news3', component: News3 },
{ path: 'news4', name: 'news4', component: News4 },
{ path: 'news5', name: 'news5', component: News5 },
{ path: 'news6', name: 'news6', component: News6 },
{ path: 'news7', name: 'news7', component: News7 },
{ path: 'news8', name: 'news8', component: News8 },
{ path: 'news9', name: 'news9', component: News9 },

// protected
{ path: 'inquiry', name: 'inquiry', component: Inquiry, meta:{requiresAuth:true}},
{ path: 'inquiryResult/:req_id', name: 'inquiryResult', component: InquiryResult, meta:{requiresAuth:true}},

{ path: 'request/:req_id', name: 'requestSent', component: Sent },
{ path: 'soon', name: 'soon', component: Soon },

{ path: 'NetServices', name:'netServices', component: Services, meta:{requiresAuth:true}},
{ path: 'mNetServices', name:'mnetServices', component: Services, meta:{requiresAuth:true}},

{
path:'services',
component:ServicesComp,
children:[

{ path:'electronicservices', name:'electronicservices', component:Services, meta:{requiresAuth:true}},

{ path:'electronicservices/regulations/:docType', name:'regulations', component:DocRegulations, meta:{requiresAuth:true}},

{ path:'electronicservices/birthfirsttime', name:'birthFirstTimeRequest', component:FirstBirtDoc, meta:{requiresAuth:true}},

{ path:'electronicservices/birth', name:'birthRequest', component:BirthDoc, meta:{requiresAuth:true}},

{ path:'electronicservices/death', name:'deathRequest', component:DeathDoc, meta:{requiresAuth:true}},

{ path:'electronicservices/nid', name:'nidRequest', component:NidDoc, meta:{requiresAuth:true}},

{ path:'electronicservices/divorce', name:'divorceRequest', component:DivorceDoc, meta:{requiresAuth:true}},

{ path:'electronicservices/marriage', name:'marriageRequest', component:MarriageDoc, meta:{requiresAuth:true}},

{ path:'electronicservices/personalrecord', name:'personalrecord', component:PersonalRecord, meta:{requiresAuth:true}},

{ path:'electronicservices/familyrecord', name:'familyrecord', component:FamilyRecord, meta:{requiresAuth:true}},

{ path:'electronicservices/nidform', name:'nidform', component:NidForm, meta:{requiresAuth:true}},

{ path:'translatedservices', name:'translatedservices', component:TranslatedServices, meta:{requiresAuth:true}},

{ path:'translatedservices/regulations/:docType', name:'translateddocsreg', component:translatedDocsReg, meta:{requiresAuth:true}},

{ path:'translatedservices/birth', name:'translatedbirthRequest', component:translatedBirthDoc, meta:{requiresAuth:true}},

{ path:'translatedservices/death', name:'translateddeathRequest', component:translatedDeathDoc, meta:{requiresAuth:true}},

{ path:'translatedservices/divorce', name:'translateddivorceRequest', component:translatedDivorceDoc, meta:{requiresAuth:true}},

{ path:'translatedservices/marriage', name:'translatedmarriageRequest', component:translatedMarriageDoc, meta:{requiresAuth:true}},

{ path:'translatedservices/personalrecord', name:'translatedpersonalrecord', component:translatedPersonalRecord, meta:{requiresAuth:true}},

{ path:'translatedservices/familyrecord', name:'translatedfamilyrecord', component:translatedFamilyRecord, meta:{requiresAuth:true}}

]
}

]
}
];

// ─── Router Instance ──────────────────────────────────────────────

const router = createRouter({
  history: createWebHistory(getRouterBase()),
  routes
});


// ─── Global Navigation Guard ──────────────────────────────────────

/**
 * ------------------------------------------------------------------
 * OAuth Authentication Guard
 * ------------------------------------------------------------------
 *
 * Only service-related routes require authentication.
 * The homepage remains PUBLIC.
 *
 * Authentication flow:
 *
 * 1️⃣ User navigates to protected route
 *       /services/*
 *
 * 2️⃣ Router checks session using:
 *       /oauth2/auth
 *
 * 3️⃣ oauth2-proxy responses:
 *
 *      202 → user authenticated
 *      401 → user not authenticated
 *
 * 4️⃣ If authenticated → allow navigation
 *
 * 5️⃣ If not authenticated:
 *      - save requested route
 *      - redirect user to oauth login
 */

router.beforeEach((to, from, next) => {

  const needsAuth = to.matched.some((record) => record.meta?.requiresAuth);

  if (!needsAuth) {
    next();
    return;
  }

  const authCheck = getAuthCheckUrl();
  const loginUrl = buildLoginUrl(to.fullPath);

  fetch(authCheck, { credentials: "include" })

    .then((response) => {

      if (response.status === 202) {
        next();
        return;
      }

      /**
       * Store route so user returns after login
       */
      sessionStorage.setItem("app3_post_login_target", to.fullPath);
      window.location.href = loginUrl;
    })

    .catch(() => {
      sessionStorage.setItem("app3_post_login_target", to.fullPath);
      window.location.href = loginUrl;
    });

  return;
});

export default router;
